import {
  Component,
  ViewEncapsulation,
  Input,
  TemplateRef,
  ContentChildren,
  AfterContentInit,
  ViewChild,
  Output,
  EventEmitter,
  QueryList,
  OnChanges,
  SimpleChanges,
  ElementRef,
  AfterViewInit,
  CUSTOM_ELEMENTS_SCHEMA, AfterContentChecked
} from '@angular/core';
import { TidyCarrouselDirective } from '../../directives/tidy-carrousel';
import { PhotoNoteComponent } from '../photo-note/photo-note.component';

@Component({
    selector: 'tidy-carrousel',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./carrousel.component.scss'],
    template: `
    @if (contentInit) {
      <swiper-container
        #swiperContainer
        [initialSlide]="0"
        [speed]="400"
        [grabCursor]="true"
        [slidesPerView]="slidesPerView"
        [pagination]="{ clickable: true }"
        (swiperslidechange)="handleSlideChange()"
        >
        @for (template of templates; track template) {
          <swiper-slide>
            <div class="slide-wrapper">
              <ng-container class="slide-template" [ngTemplateOutlet]="template"></ng-container>
            </div>
          </swiper-slide>
        }
      </swiper-container>
    }
    `,
    standalone: false
})
export class CarrouselComponent implements AfterContentInit, AfterViewInit, OnChanges, AfterContentChecked {
  contentInit = false;
  @Input() scaleImages = false;
  isImageScaled = false;
  @Input() slidesNumber: number;
  @Input() slidesPerView = 1;
  @ContentChildren(TidyCarrouselDirective, {read: TemplateRef}) templates: TemplateRef<any>[];
  @ViewChild('swiperContainer') swiperContainer: ElementRef;
  @ContentChildren(PhotoNoteComponent) photoNotes: QueryList<PhotoNoteComponent>;
  @Output() slideIndexDidChange: EventEmitter<number> = new EventEmitter<number>();

  private swiper: any;

  ngOnChanges(changes: SimpleChanges) {
    this.photoNotes = changes.photoNotes ? changes.photoNotes.currentValue : this.photoNotes;
    this.templates = changes.templates ? changes.templates.currentValue : this.templates;

    // Update swiper if slides per view changes
    if (changes.slidesPerView && this.swiper) {
      this.swiper.params.slidesPerView = this.slidesPerView;
      this.swiper.update();
    }
  }

  ngAfterContentInit() {
    this.contentInit = true;
  }

  ngAfterViewInit() {
    // Initialize swiper reference after view init
    setTimeout(() => {
      if (this.swiperContainer && this.swiperContainer.nativeElement) {
        this.swiper = this.swiperContainer.nativeElement.swiper;
        this.scaleImagesIfNeeded();
      }
    }, 100);
  }

  ngAfterContentChecked() {
    this.scaleImagesIfNeeded();
  }

  private scaleImagesIfNeeded() {
    if (!this.isImageScaled && this.swiper && this.photoNotes) {
      const width = this.swiper.width || this.swiper.el.clientWidth;
      if (width) {
        this.photoNotes.forEach((photoNote) => {
          photoNote.setImageWidth(`${width}px`);
        });
        this.isImageScaled = true;
      }
    }
  }

  getActiveIndex() {
    if (this.swiper) {
      return this.swiper.activeIndex;
    }
    return 0;
  }

  updateSlider() {
    if (this.swiper) {
      this.swiper.update();
    }
  }

  handleSlideChange() {
    if (this.swiper) {
      this.slideIndexDidChange.emit(this.swiper.activeIndex);
    }
  }
}
